export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white pt-16 pb-8 rounded-t-[40px]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://public.readdy.ai/ai/img_res/7a20facf-c180-43e4-bc04-b977be664223.png" 
                alt="ZALETELJ d.o.o." 
                className="h-10 w-10 object-contain"
              />
              <span className="text-2xl font-bold">ZALETELJ</span>
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed">
              Securing your digital life with military-grade encryption and zero-logs privacy protection.
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-cyan-500 rounded-lg transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-cyan-500 rounded-lg transition-colors cursor-pointer">
                <i className="ri-twitter-x-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-cyan-500 rounded-lg transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('home')} className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">
                  Home
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('features')} className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">
                  VPN Features
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('security')} className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">
                  Security
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">
                  Contact
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('support')} className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">
                  Support
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('privacy')} className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">
                  Privacy Policy
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">Contact Information</h4>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <i className="ri-phone-line text-cyan-400 text-xl mt-1"></i>
                <div>
                  <p className="text-sm text-gray-400 mb-1">Phone</p>
                  <a href="tel:+18554195724" className="text-white hover:text-cyan-400 transition-colors">
                    +1 855 419 5724
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-mail-line text-cyan-400 text-xl mt-1"></i>
                <div>
                  <p className="text-sm text-gray-400 mb-1">Email</p>
                  <a href="mailto:information@zaleteljdoo.com" className="text-white hover:text-cyan-400 transition-colors">
                    information@zaleteljdoo.com
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-map-pin-line text-cyan-400 text-xl mt-1"></i>
                <div>
                  <p className="text-sm text-gray-400 mb-1">Address</p>
                  <p className="text-white">
                    Jama 16<br />
                    1234 Menges<br />
                    Slovenia
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © 2025 ZALETELJ d.o.o. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <button onClick={() => scrollToSection('privacy')} className="text-gray-400 hover:text-cyan-400 text-sm transition-colors cursor-pointer">
                Privacy Policy
              </button>
              <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-cyan-400 text-sm transition-colors">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
